export default "__VITE_PUBLIC_ASSET__05276a66__"